export default "__VITE_ASSET__dYO4ghDj__"